import {Falsy, SearchTypes, logger} from 'tizra'
import {useHack} from './useHack'
import {useSearchTypes} from './useSearchTypes'
import {useTypeInfo} from './useTypeInfo'

const log = logger('useTypeDefs')

/**
 * Call either /api/type-info or /api/search-types to assemble type definitions,
 * depending first on the `typeInfo` hack, and second on whether /api/type-info
 * returns the information we need.
 *
 * Returns undefined while fetching, then object of type definitions.
 */
export const useTypeDefs = (
  _metaTypes?: string[] | Falsy,
  _typeInfo?: boolean,
): SearchTypes | undefined => {
  const typeInfoHack = useHack('typeInfo')
  const typeInfoEnabled = _typeInfo ?? typeInfoHack

  // Assemble searchTypes from /api/type-info if enabled.
  // Returns null if type-info return wasn't sufficient for operation.
  const searchTypesFromTypeInfo = useTypeInfo(typeInfoEnabled)

  // Check if the type-info response included everything we need.
  let searchTypesEnabled = !typeInfoEnabled || searchTypesFromTypeInfo === null
  if (!searchTypesEnabled && _metaTypes && searchTypesFromTypeInfo) {
    for (const m of _metaTypes) {
      if (!searchTypesFromTypeInfo[m]) {
        log.once(m)?.error(`type-info missing ${m}, punting to search-types`)
        searchTypesEnabled = true
        break
      }
    }
  }

  // Fetch from /api/search-types if necessary.
  const searchTypesFromSearchTypes = useSearchTypes(
    searchTypesEnabled && _metaTypes,
  )

  return searchTypesEnabled ?
      searchTypesFromSearchTypes
    : (searchTypesFromTypeInfo ?? undefined)
}
